
// storage option when underlying storage is not available
const EphemeralStorage = {
    _store: {},
    getItem: (key) => {
        return this._store[key]
    },
    removeItem: (key) => {
        delete this._store[key]
    },
    setItem: (key, value) => {
        this._store[key] = value
    }
}

export default class StoreServiceBase { 

    constructor(underlyingStorage) {
        this.storage = underlyingStorage || EphemeralStorage
    }

    get(key) {
        return new Promise((resolve, reject) => {
            try {
                resolve(this.storage.getItem(key))
            }
            catch (error) {
                reject(error)
            }
        })
    }

    remove(key) {
        return new Promise((resolve, reject) => {
            try {
                resolve(this.storage.removeItem(key))
            }
            catch (error) {
                reject(error)
            }
        })
    }

    set(key, value) {
        return new Promise((resolve, reject) => {
            try {
                resolve(this.storage.setItem(key, value))
            }
            catch (error) {
                reject(error)
            }
        })
    }

}



// WEBPACK FOOTER //
// src/services/ephemeral-store/base.js